import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";
import { Cidade } from "./cidadesService";

const urlBase = `${config.urlApi}/Relatorios`;  //import.meta.env.VITE_URL_API;

const urls = {
  mensalidades: `${urlBase}/Mensalidades`,
  clientesContrato: `${urlBase}/ClientesContrato`,
  clientesDependentes: `${urlBase}/ClientesDependentes`,
  clientes: `${urlBase}/Clientes`,
}


function getToken(): string {

  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);

    if (user && user.accessToken) {
      return `Bearer  ${user.accessToken}`;
    } else {
      return "";
    }
  }
  else
    return "";
}



export interface RetornoGridDTO<T> {
    totalRegistros: number;
    dados: T[];
}


export const mensalidades = (params: FiltroMensalidades | null | any): Promise<RetornoGridDTO<RelMensDTO>> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.mensalidades,  params)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export interface FiltroMensalidades {
    nome?: string;
    contratoId?: number;
    investidoresId: number[] | null;
    vendedoresId: number[] | null;
    cidadesIds: number[] | null;
    clientesIds: number[] | null;
    somarCortesias: boolean | null;
    mes?: number | null;
    ano?: number | null;
    dataPagtoInicial: string | null;
    dataPagtoFinal: string | null;
    dataVencInicial: string | null;
    dataVencFinal: string | null;
    status?: string | null;
}

export const clientesContrato = (params: FiltroClientesContrato | null | any): Promise<RetornoGridDTO<RelClienteContratoDTO>> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.clientesContrato, params)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export interface FiltroClientesContrato {
    comContrato: boolean | null;
    assinado: boolean | null;
    vendedorId: number | null;
    ativo: boolean | null;
    cortesia: boolean | null;
    dataCadastroInicial: string | null;
    dataCadastroFinal: string | null;
}

export interface RelClienteContratoDTO {
    clienteId: number;
    nome: string;
    cpf: string;
    dataNascimento: string | null;
    dataCadastro: string | null;
    ativo: boolean;
    contratoId: number | null;
    planoNome: string | null;
    vendedorId: number | null;
    vendedorNome: string | null;
    dataFim: string | null;
    dataAssinatura: string | null;
    cidadeNome: string | null;
}

export const clientesDependentes = (params: FiltroClientesDependentes | null | any): Promise<RetornoGridDTO<RelClienteDependenteDTO>> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.clientesDependentes, params)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export interface FiltroClientesDependentes {
    vendedorId: number | null;
    planoId: number | null;
    ativo: boolean | null;
    dataCadastroInicial: string | null;
    dataCadastroFinal: string | null;
}

export interface RelClienteDependenteDTO {
    clienteId: number;
    nome: string;
    cpf: string;
    nomeConjuge: string | null;
    cpfConjuge: string | null;
    parentesco: string | null;
    nomeDependente: string | null;
    dataNascimentoDependente: string | null;
    cpfDependente: string | null;
    telefoneDependente: string | null;
    ativo: boolean;
    dataCadastro: string | null;
}

export const clientes = (params: FiltroRelatorioClientes | null | any): Promise<RetornoGridDTO<RelClienteDTO>> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.clientes, params)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export interface FiltroRelatorioClientes {
    ativo: boolean | null;
    cidadeId: number | null;
    empresaId?: number | null;
    comDependentes: boolean | null;
    dataNascimentoInicial: string | null;
    dataNascimentoFinal: string | null;
}

export interface RelClienteDTO {
    clienteId: number;
    nome: string;
    cpf: string;
    dataNascimento?: Date | null;
    telefone?: string | null;
    celular?: string | null;
    cidadeNome?: string | null;
    ativo: boolean;
    dependentes: RelClienteDependenteMiniDTO[];
}

export interface RelClienteDependenteMiniDTO {
    nome: string;
    dataNascimento: string | null;
    cpf: string | null;
    parentesco: string | null;
}

export interface RelMensDTO {
    id: number;
    contratoId: number | null;
    dataInicio: string | null;
    clienteId: number | null;
    clienteNome: string | null;
    cidadeId: number | null;
    cidadeNome: string;
    investidorId: number | null;
    investidorNome: string;
    vendedorId: number | null;
    vendedorNome: string;
    dataVencimento: string | null;
    dataPagamento: string | null;
    valor: number;
    valorPago: number;
    cortesia: boolean;
    parcela: number ;
    referente: string;
    boletoId?: number;
    boletoAntigo: boolean;
    boletoStatus?: string;
    podeImprimir?: boolean;
}